<template>
  <div class="searchCondition_wrapper">
    <el-checkbox-group v-model="checkList" size="small" @change="onChange">
      <el-checkbox
        border
        v-for="item in options"
        :key="item[valueProps]"
        :label="item[valueProps]"
        >{{ item[labelProps] }}</el-checkbox
      >
    </el-checkbox-group>
  </div>
</template>

<script>
export default {
  props: {
    options: {
      type: Array,
      default: () => []
    },
    value: {
      type: Array,
      default: () => []
    },
    labelProps: {
      type: String
    },
    valueProps: {
      type: String
    }
  },
  data() {
    return {
      checkList: []
    };
  },
  watch: {
    value: {
      handler(val) {
        this.checkList = val;
      },
      deep: true
    }
  },
  created() {
    this.checkList = this.value;
  },
  methods: {
    onChange(val) {
      //console.log(this.options);
      //console.log(this.valueProps);
      console.log(val);
      this.$emit('input', this.checkList);
    }
  }
};
</script>

<style lang="less">
.searchCondition {
  &_wrapper {
    .el-checkbox {
      margin-right: 0 !important;
    }
  }
}
</style>
